import React from 'react';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { SELF_REPORTED_INCOME } from 'types/morph.pagePosition.constants';
import { useSelfReportedIncomeModule } from './hooks/SelfReportedIncome.hook';
import SelfReportedIncomeView from './SelfReportedIncomeView';

const SelfReportedIncomeController = props => {
  const { userInfo, eventHandler, modulePosition } =
    props;

  const { annualIncomeInput, onChangeIncome, onClickSubmit, isSubmitDisabled } =
    useSelfReportedIncomeModule(
      {
        annualIncome: userInfo.annualIncome,
        isDefaultDisabled: false,
      },
      eventHandler,
    );

  const selfReportedIncomeStates = {
    annualIncomeInput,
    onChangeIncome,
    onClickSubmit,
    isSubmitDisabled,
  };

  const atr = getViewModuleTrackingAttributes(
    SELF_REPORTED_INCOME,
    modulePosition,
  );

  let finalAttributes = {...atr, 'Module Heading': "Is your income correct?" };  

  useViewModule(finalAttributes);
  const seenPixel = useSeenModulePixel(finalAttributes);


  return <SelfReportedIncomeView
    {...props}
    {...selfReportedIncomeStates}
    seenPixel={seenPixel}
  />
};

export default SelfReportedIncomeController;
